/**
 * AONA Luxury AI-Powered Search Bar & Suggested Products Dropdown
 * Inspired by Pepperfry with NVIDIA AI Dynamic Search Term Generation
 */

(function() {
  var NVIDIA_API_KEY = "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";
  var NVIDIA_ENDPOINT = "https://integrate.api.nvidia.com/v1/chat/completions";
  var STORAGE_TERMS_KEY = "aona_ai_search_terms_cache";
  var STORAGE_RECENT_KEY = "aona_recent_searches";

  var defaultTerms = [
    '"Brass Ganesha Idols"',
    '"Radha Krishna Murti"',
    '"Urli Bowls with Candles"',
    '"Handcrafted Pooja Diyas"',
    '"Lord Shiva Shankar Statue"',
    '"Buddha for Living Room"',
    '"Ashoka Stambh Emblem"',
    '"Karungali Mala & Bracelet"',
    '"Brass Peacock Lamp"',
    '"Ram Darbar Idol"',
    '"Brass Elephant Pair"',
    '"Tirupati Balaji Statue"',
    '"Vintage Bronze Sculptures"',
    '"Home Mandir Decor"'
  ];

  var searchTerms = defaultTerms.slice();
  var currentTermIdx = 0;
  var rotateInterval = null;
  var debounceTimer = null;
  var cachedSuggestedProducts = null;

  // Load cached AI terms from localStorage
  try {
    var cached = JSON.parse(localStorage.getItem(STORAGE_TERMS_KEY) || 'null');
    if (cached && cached.terms && cached.terms.length > 0 && (Date.now() - cached.timestamp < 86400000)) {
      searchTerms = cached.terms;
    }
  } catch(e) {}

  // Fetch fresh AI suggestions in background via NVIDIA API
  function fetchAiSearchSuggestions() {
    var prompt = 'Generate 20 popular search queries for a luxury Indian home decor and handcrafted brass spiritual idol brand (e.g., Brass Ganesha, Urli Bowls, Radha Krishna, Lord Shiva, Pooja Diyas, Buddha Statue, Karungali, Ashoka Emblem). Respond strictly in valid JSON format: {"suggestions": ["term 1", "term 2", ...]}';

    fetch(NVIDIA_ENDPOINT, {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer ' + NVIDIA_API_KEY,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        model: 'openai/gpt-oss-20b',
        messages: [{ role: 'user', content: prompt }],
        max_tokens: 600,
        temperature: 0.2,
        stream: false
      })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('NVIDIA HTTP ' + res.status);
      return res.json();
    })
    .then(function(data) {
      var content = data.choices && data.choices[0] && data.choices[0].message && data.choices[0].message.content;
      if (!content) return;
      var jsonMatch = content.match(/\{[\s\S]*\}/);
      var parsed = jsonMatch ? JSON.parse(jsonMatch[0]) : JSON.parse(content);
      var suggestions = parsed.suggestions || parsed.queries || [];
      if (Array.isArray(suggestions) && suggestions.length > 5) {
        var formatted = suggestions.map(function(s) {
          s = s.replace(/^["']|["']$/g, '');
          return '"' + s + '"';
        });
        searchTerms = formatted;
        try {
          localStorage.setItem(STORAGE_TERMS_KEY, JSON.stringify({
            terms: formatted,
            timestamp: Date.now()
          }));
        } catch(e) {}
        renderTrendingChips(suggestions);
      }
    })
    .catch(function(err) {
      console.warn('Using local search suggestions fallback:', err);
    });
  }

  function initPlaceholderRotation() {
    var input = document.querySelector('.aona-search-input-field');
    var box = document.querySelector('.aona-placeholder-sliding-box');
    var placeholderWrapper = document.querySelector('.aona-animated-placeholder');
    if (!input || !box || !placeholderWrapper) return;

    if (rotateInterval) clearInterval(rotateInterval);

    function rotateNext() {
      if (document.activeElement === input || input.value.trim() !== '') return;

      var currentEl = box.querySelector('.aona-placeholder-sliding-term');
      currentTermIdx = (currentTermIdx + 1) % searchTerms.length;

      var nextEl = document.createElement('span');
      nextEl.className = 'aona-placeholder-sliding-term slide-in-start';
      nextEl.textContent = searchTerms[currentTermIdx];

      if (currentEl) {
        currentEl.classList.remove('active');
        currentEl.classList.add('slide-out');
        setTimeout(function() {
          if (currentEl && currentEl.parentNode) {
            currentEl.parentNode.removeChild(currentEl);
          }
        }, 400);
      }

      box.appendChild(nextEl);

      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          nextEl.classList.remove('slide-in-start');
          nextEl.classList.add('active');
        });
      });
    }

    rotateInterval = setInterval(rotateNext, 2600);

    function syncPlaceholder() {
      if (document.activeElement === input || input.value.trim() !== '') {
        placeholderWrapper.classList.add('is-hidden');
      } else {
        placeholderWrapper.classList.remove('is-hidden');
      }
    }

    input.addEventListener('input', syncPlaceholder);
    input.addEventListener('focus', syncPlaceholder);
    input.addEventListener('blur', syncPlaceholder);
  }

  function renderTrendingChips(customTags) {
    var container = document.querySelector('.aona-search-tags-grid');
    if (!container) return;

    var tags = customTags || [
      'Brass Ganesha',
      'Urli Bowls',
      'Radha Krishna',
      'Pooja Diya',
      'Lord Shiva',
      'Buddha Idols',
      'Karungali',
      'Ashoka Emblem',
      'Brass Nataraja',
      'Peacock Lamp'
    ];

    var html = '';
    tags.slice(0, 10).forEach(function(tag) {
      var clean = tag.replace(/^["']|["']$/g, '');
      html += '<a href="/search?q=' + encodeURIComponent(clean) + '" class="aona-search-tag-chip" data-search-term="' + clean + '">' +
                '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>' +
                clean +
              '</a>';
    });
    container.innerHTML = html;

    container.querySelectorAll('.aona-search-tag-chip').forEach(function(chip) {
      chip.addEventListener('click', function(e) {
        var term = this.dataset.searchTerm;
        saveRecentSearch(term);
      });
    });
  }

  function fetchSuggestedProducts() {
    var grid = document.querySelector('.aona-search-products-grid');
    if (!grid) return;

    if (cachedSuggestedProducts) {
      renderSuggestedProductsGrid(cachedSuggestedProducts);
      return;
    }

    fetch('/search/suggest.json?q=brass&resources[type]=product')
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(data) {
        var prods = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        if (prods.length > 0) {
          cachedSuggestedProducts = prods.slice(0, 6);
          renderSuggestedProductsGrid(cachedSuggestedProducts);
        } else {
          return fetch('/products.json?limit=6')
            .then(function(r) { return r.json(); })
            .then(function(d) {
              if (d && d.products) {
                cachedSuggestedProducts = d.products;
                renderSuggestedProductsGrid(cachedSuggestedProducts);
              }
            });
        }
      })
      .catch(function(err) {
        console.warn('Suggested products error:', err);
      });
  }

  function renderSuggestedProductsGrid(products) {
    var grid = document.querySelector('.aona-search-products-grid');
    if (!grid || !products || products.length === 0) return;

    var html = '';
    products.slice(0, 6).forEach(function(p) {
      var priceNum = Number(p.price || (p.variants && p.variants[0] ? p.variants[0].price : 0));
      var compareNum = Number(p.compare_at_price_min || p.compare_at_price || (p.variants && p.variants[0] ? p.variants[0].compare_at_price : 0));
      var priceStr = '₹' + Math.round(priceNum).toLocaleString('en-IN');
      var mrpStr = compareNum > priceNum ? '₹' + Math.round(compareNum).toLocaleString('en-IN') : '';
      var discount = compareNum > priceNum ? Math.round(((compareNum - priceNum) / compareNum) * 100) + '% OFF' : '';
      var img = p.image || p.featured_image || (p.images && p.images[0] ? p.images[0].src : '');
      var url = p.url ? p.url.split('?')[0] : ('/products/' + p.handle);

      html += `
        <a href="${url}" class="aona-search-product-item">
          <img src="${img}" alt="${p.title}" class="aona-search-product-thumb" loading="lazy" />
          <div class="aona-search-product-meta">
            <span class="aona-search-product-title">${p.title}</span>
            <div class="aona-search-product-price-row">
              <span class="aona-search-product-price">${priceStr}</span>
              ${mrpStr ? `<span class="aona-search-product-mrp">${mrpStr}</span>` : ''}
              ${discount ? `<span class="aona-search-product-badge">${discount}</span>` : ''}
            </div>
          </div>
        </a>
      `;
    });
    grid.innerHTML = html;
  }

  function loadRecentSearches() {
    var container = document.querySelector('.aona-recent-searches-section');
    var listEl = document.querySelector('.aona-recent-searches-list');
    if (!container || !listEl) return;

    var list = [];
    try {
      list = JSON.parse(localStorage.getItem(STORAGE_RECENT_KEY) || '[]');
    } catch(e) {}

    if (list.length === 0) {
      container.style.display = 'none';
      return;
    }

    container.style.display = 'block';
    var html = '';
    list.slice(0, 6).forEach(function(term) {
      html += '<a href="/search?q=' + encodeURIComponent(term) + '" class="aona-search-tag-chip">' +
                '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>' +
                term +
              '</a>';
    });
    listEl.innerHTML = html;
  }

  function saveRecentSearch(term) {
    if (!term || term.trim() === '') return;
    term = term.trim();
    try {
      var list = JSON.parse(localStorage.getItem(STORAGE_RECENT_KEY) || '[]');
      list = list.filter(function(t) { return t.toLowerCase() !== term.toLowerCase(); });
      list.unshift(term);
      if (list.length > 8) list = list.slice(0, 8);
      localStorage.setItem(STORAGE_RECENT_KEY, JSON.stringify(list));
    } catch(e) {}
  }

  function initPredictiveLiveSearch() {
    var input = document.querySelector('.aona-search-input-field');
    var defaultContent = document.querySelector('.aona-search-default-content');
    var predictiveContent = document.querySelector('.aona-predictive-results');
    var predictiveList = document.querySelector('.aona-predictive-list');
    var viewAllBtn = document.querySelector('.aona-predictive-view-all');
    if (!input || !defaultContent || !predictiveContent || !predictiveList) return;

    input.addEventListener('input', function() {
      var val = this.value.trim();
      if (debounceTimer) clearTimeout(debounceTimer);

      if (val.length < 2) {
        defaultContent.style.display = 'block';
        predictiveContent.classList.remove('active');
        return;
      }

      debounceTimer = setTimeout(function() {
        fetch('/search/suggest.json?q=' + encodeURIComponent(val) + '&resources[type]=product')
          .then(function(r) { return r.ok ? r.json() : null; })
          .then(function(data) {
            var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
            if (products.length > 0) {
              defaultContent.style.display = 'none';
              predictiveContent.classList.add('active');

              var html = '';
              products.slice(0, 6).forEach(function(p) {
                var priceStr = '₹' + Math.round(Number(p.price || 0)).toLocaleString('en-IN');
                var img = p.image || p.featured_image || '';
                var url = p.url ? p.url.split('?')[0] : ('/products/' + p.handle);

                html += `
                  <a href="${url}" class="aona-predictive-item">
                    <img src="${img}" alt="${p.title}" class="aona-predictive-item-img" />
                    <span class="aona-predictive-item-title">${p.title}</span>
                    <span class="aona-search-product-price">${priceStr}</span>
                  </a>
                `;
              });
              predictiveList.innerHTML = html;
              if (viewAllBtn) {
                viewAllBtn.href = '/search?q=' + encodeURIComponent(val);
                viewAllBtn.textContent = 'VIEW ALL RESULTS FOR "' + val.toUpperCase() + '" ➔';
              }
            } else {
              defaultContent.style.display = 'block';
              predictiveContent.classList.remove('active');
            }
          })
          .catch(function() {
            defaultContent.style.display = 'block';
            predictiveContent.classList.remove('active');
          });
      }, 240);
    });
  }

  function initDropdownEvents() {
    var wrapper = document.querySelector('.aona-search-bar-wrapper');
    var input = document.querySelector('.aona-search-input-field');
    var modal = document.querySelector('.aona-search-dropdown-modal');
    var form = document.querySelector('.aona-search-form-container form');
    var clearRecentBtn = document.querySelector('.aona-search-clear-recent');

    if (!input || !modal) return;

    function openDropdown() {
      modal.classList.add('active');
      loadRecentSearches();
      fetchSuggestedProducts();
    }

    function closeDropdown() {
      modal.classList.remove('active');
    }

    input.addEventListener('focus', openDropdown);
    input.addEventListener('click', openDropdown);

    document.addEventListener('click', function(e) {
      if (wrapper && !wrapper.contains(e.target)) {
        closeDropdown();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        closeDropdown();
        input.blur();
      }
    });

    if (form) {
      form.addEventListener('submit', function() {
        saveRecentSearch(input.value);
      });
    }

    if (clearRecentBtn) {
      clearRecentBtn.addEventListener('click', function(e) {
        e.preventDefault();
        try {
          localStorage.removeItem(STORAGE_RECENT_KEY);
        } catch(e) {}
        loadRecentSearches();
      });
    }
  }

  function init() {
    initPlaceholderRotation();
    renderTrendingChips();
    initDropdownEvents();
    initPredictiveLiveSearch();
    // Background AI enhancement
    fetchAiSearchSuggestions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
